const styles = theme => ({
  dropdownButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    minWidth: '32px',
    padding: '8px',
  },
  dropdownButtonLabel: {
    '& img': {
      margin: '0 !important',
    },
  },
});

export default styles;
